<template>
  <div class="marks">
    <div class="marks__inner" v-if="getSets && getSets.length">
      <div v-for="set in getSets" :key="set.id" class="set">
        <h1 class="set__title">{{set.name}}</h1>
        <div class="set__markers">
        <SidebarMark
          v-for="mark in set.markers"
          :key="mark._id"
          :mark="mark"
          :handleClick="() => handleClick(mark.name, mark.image)"
        />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";

import SidebarMark from "./SidebarMark";

import api from "../../api";
import { initDraggable } from "../../utils";
import fake from "../../fake";

export default {
  data() {
    return {
      isPopupOpen: false
    };
  },
  computed: {
    ...mapState(["sets, selectedProject"]),
    ...mapGetters(["getSelectedProject", "getSets"])
  },
  methods: {
    ...mapMutations(["setSets", "openPopup", "createMark"]),
    handleClick(name, image) {
      this.openPopup("addMark");
      this.createMark({
        x: 0,
        y: 0,
        type: name,
        contentType: "link",
        link: {
          en: "",
          de: ""
        },
        label: {
          en: "",
          de: ""
        },
        image: image,
        id: `f${(+new Date).toString(16)}`
      });
    }
  },
  mounted() {
    if (!this.getSets || !this.getSets.length) {
      this.setSets(this.getSelectedProject.sets);
    }
  },
  components: {
    SidebarMark
  }
};
</script>

<style lang="scss" scoped>
.marks__inner {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.set {
  &__title {
    color: #4C4C4C;
    font-size: 28px;
    font-weight: 400;
  }

  &__markers {
    display: flex;
    flex-wrap: wrap;
  }
}
</style>
